interface P { width?: number | string; height?: number | string; radius?: number | string }
export function Skeleton({ width = "100%", height = 14, radius = 8 }: P) {
  return <div className="skeleton" style={{ width, height, borderRadius: radius }} />;
}
